import { useNavigate } from "react-router-dom";
import {
  HeaderMain,
  HeaderOptions,
  MainLogo,
  AccountIcon,
} from "../StyledComponents/AppStyles";

export default function Header() {
  const navigate = useNavigate();

  return (
    <HeaderMain>
      <nav>
        <span onClick={() => navigate('/')}>
          <MainLogo />
        </span>
        <HeaderOptions id="rem">
          <span>
            <a>Insurance</a>
          </span>
          <span>
            <a>Rentals</a>
          </span>
          <span>
            <a>About Us</a>
          </span>
          <span>
            <a>Resources</a>
          </span>
          <span>
            <AccountIcon />
            <a>Log In</a>
          </span>
        </HeaderOptions>
      </nav>
    </HeaderMain>
  );
}
